const supportTopics = [
  { id: "setup-and-configuration", color: "yellow", icon: "settings" },
  { id: "importing-and-migrating-data", color: "fucsia", icon: "migration" },
  { id: "account-and-security", color: "orange", icon: "security" },
  { id: "contact-management", color: "fucsia", icon: "teams" },
  { id: "calendar-and-tasks", color: "cyan", icon: "tasks" },
  { id: "workflow-automation", color: "fucsia", icon: "workflow-automation" },
  { id: "projects-and-events", color: "yellow", icon: "projects" },
  { id: "sales", color: "fucsia", icon: "sales" },
  { id: "business-insights", color: "cyan", icon: "reports" },
  { id: "mobile-apps", color: "fucsia", icon: "settings", hidden: true },
  { id: "integrations", color: "orange", icon: "integrations" },
]

module.exports = supportTopics
